import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecordLock } from '../../contexts/RecordLockContext'

import DeleteConfirmation from './DeleteConfirmation'

import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'

import EditIcon from '@mui/icons-material/Edit'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import ListIcon from '@mui/icons-material/List'

const ActionBar = ({
  id,
  _id,
  record,
  type,
  values,
  formId,
  initialValues,
  setValues,
  handleEdit,
  editToolTip,
  handleCancelChanges,
  saveToolTip,
  handleNew,
  newToolTip,
  handleList,
  listToolTip,
  handleDeleteFn,
  deleteToolTip,
  disabled,
  disableDelete,
  disableEdit,
  newOnly,
  editOnly,
}) => {
  const navigate = useNavigate()
  const { recordLock, setRecordLock } = useRecordLock()
  const [dataSnap, setDataSnap] = useState({})
  const handleEditDefault = () => {
    if (!id && values._id) {
      navigate(`/${record}/${values._id}`)
    }
    setDataSnap(values)
    setRecordLock(false)
  }

  const handleCancelChangesDefault = () => {
    setValues(dataSnap)
    setRecordLock(true)
    if (!id) {
      navigate('/')
    }
  }

  const handleNewDefault = () => {
    navigate(`/${record}`)
    setValues(initialValues)
    setRecordLock(false)
  }

  const handleListDefault = () => {
    navigate(`/${record}/list`)
  }

  return (
    <>
      <Grid
        container
        justifyContent='center'
        sx={{
          borderTop: '1px solid #ced4da',
          width: '100%',
          position: 'fixed',
          bottom: 0,
          height: 60,
          zIndex: 10,
          backgroundColor: 'white',
        }}
      >
        {!disableEdit && !disabled && !newOnly && recordLock && (
          <Grid item>
            <Tooltip title={editToolTip ? editToolTip : 'Edit Record'} arrow>
              <Button
                variant='outlined'
                sx={{ py: 1, my: 1, mx: 0.5 }}
                color='warning'
                disabled={disabled}
                onClick={handleEdit ? handleEdit : handleEditDefault}
              >
                <EditIcon />
              </Button>
            </Tooltip>
          </Grid>
        )}
        {!disabled && !newOnly && !recordLock && (
          <Grid item>
            <Tooltip title={saveToolTip ? saveToolTip : 'Save Record'} arrow>
              <Button
                form={formId}
                type='submit'
                variant='outlined'
                sx={{ py: 1, m: 1 }}
                color='warning'
                disabled={disabled}
              >
                <SaveOutlinedIcon />
              </Button>
            </Tooltip>
          </Grid>
        )}

        {!disabled && !newOnly && !recordLock && (
          <Grid item>
            <Tooltip title='Cancel Changes' arrow>
              <Button
                variant='outlined'
                sx={{ py: 1, m: 1 }}
                color='error'
                disabled={disabled}
                onClick={
                  handleCancelChanges
                    ? handleCancelChanges
                    : handleCancelChangesDefault
                }
              >
                <ReplayOutlinedIcon />
              </Button>
            </Tooltip>
          </Grid>
        )}

        {!disabled && !editOnly && recordLock && (
          <Grid item>
            <Tooltip title={newToolTip ? newToolTip : 'New Record'} arrow>
              <Button
                variant='outlined'
                sx={{ py: 1, m: 1 }}
                color='success'
                disabled={disabled}
                onClick={handleNew ? handleNew : handleNewDefault}
              >
                <AddCircleOutlineIcon />
              </Button>
            </Tooltip>
          </Grid>
        )}

        {!newOnly && !editOnly && recordLock && (
          <Grid item>
            <Tooltip title={listToolTip ? listToolTip : 'List Records'} arrow>
              <Button
                variant='contained'
                sx={{ py: 1, m: 1 }}
                color='success'
                disabled={disabled}
                onClick={handleList ? handleList : handleListDefault}
              >
                <ListIcon />
              </Button>
            </Tooltip>
          </Grid>
        )}

        {!disableDelete && id && !newOnly && recordLock && !editOnly && (
          <Grid item>
            <DeleteConfirmation
              openBtn='actionBar'
              deleteToolTip={deleteToolTip}
              type={type}
              id={id}
              handleDeleteFn={handleDeleteFn}
            />
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default ActionBar
